const containerStyles = (tokens) => ({
    variants: {
        grey: {
            padding: tokens.Spacing05,
            overflowY: 'auto',
            borderRadius: tokens.BorderRadius04,
            backgroundColor: tokens.CanvasSelectionGrey,
        },
    },
});
export default containerStyles;
